/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ViewAppliedRequest {
    getFixupPrototypeFunction() { return ViewAppliedRequest.fixupPrototype; }

    static newInstance(model: Partial<ViewAppliedRequest>): ViewAppliedRequest {
        let obj = Object.assign(new ViewAppliedRequest(), model);
        ViewAppliedRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ViewAppliedRequest>): ViewAppliedRequest {
        if (!model) return null;
        return ViewAppliedRequest.newInstance(<ViewAppliedRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ViewAppliedRequest) {
        if (!obj) return;

        models.ViewAppliedRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ViewAppliedRequest): boolean {
        Object.setPrototypeOf(obj, ViewAppliedRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Specify the monitoring_template_uri of the applied template to view what is applied. Template URI can be obtained from List operation alert configuration templates
     */
    monitoring_template_uri: string;

    /**
     * Cloud account id is unique can be obtained from the list cloud account api.
     */
    cloud_account_id: string;

    /**
     * Resource Type can be obtained from List Operation visibility details
     */
    resource_type: string;

    /**
     * Resource can be obtained from get operations resource details
     */
    resource: string;

    /**
     * Metric name can be obtained from List Operation visibility details
     */
    metric_name: string;

    /**
     * Specify the criticality
     */
    criticality: models.TemplateAlertCriticality;

    /**
     * Specify the metric_type
     */
    metric_type: models.TemplateAlertMetricType;

    /**
     * The data to be filtered based on the specified status
     */
    status: models.AppliedAlertStatus;

}
